import styleSelect from '../libs/style-select';

export default () => {
  const selects = document.querySelectorAll('.default-input select');
  if (selects.length === 0) return;

  selects.forEach(select => {
    styleSelect(select);
  });
}